export default __webpack_public_path__ + "images/0x11dc28d01984079b7efe7763b533e6ed9e3722b9.png";